'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/thematic-bar-chart-tooltip-template.html'));
var ThematicBarChartController = function ThematicBarChartController($timeout, $scope, $filter, $q, BrushSelectionFilter, dataProviderService, chartFormatter, currentStateCriteriaService, dataRetrieverConstantsService, dowConversionService, brushRangesService, userPreferencesService, representationService, analysisMetricService, gridMaximizeConstants) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var chartsWhichBarsShouldNotBeHidden = ['Legs'];
  $scope.mode = currentStateCriteriaService.isPostDeparture() ? $scope.postDepartureModeName : $scope.defaultMode;
  $scope.switchingModes = $scope.postDepartureModeName ? [$scope.defaultMode, $scope.postDepartureModeName] : [$scope.defaultMode];
  $scope.ranges = [];
  function getMetrics() {
    var metricId = dataProviderService.getSelectedMetric($scope.screen, $scope.mode).id;
    return analysisMetricService.getAnalysisMetric($scope.screen).getMetricValues($scope.mode, metricId);
  }
  $scope.chartFormatters = {
    xAxisTickFormatter: chartFormatter.humanReadable,
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d, representationService.getYAxisFormat($scope.screenState.dataRepresentation));
    },
    tooltipFormatter: function tooltipFormatter(d) {
      var isFlightScreen = $scope.screen === gridMaximizeConstants.FLIGHT_SCREEN;
      var isDow = $scope.type === 'thematic-demand-chart-any-dow' || $scope.type === 'thematic-flight-chart-dow';
      var tooltipLabel = isDow ? dowConversionService.shortIdToFullId([d.label])[0] : d.label;
      var tooltipModel = representationService.prepareTooltipModel(getMetrics(), d, {
        label: $scope.preLabel ? $scope.preLabel + tooltipLabel : tooltipLabel,
        representation: $scope.screenState.dataRepresentation,
        selectedReference: $scope.screenState.selectedReference,
        postDeparture: isFlightScreen ? currentStateCriteriaService.isPostDeparture() : false
      }, $scope.screen);
      return tooltipTemplate(tooltipModel);
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'market-analysis-thematic-range-chart ' + $scope.mode + ' ' + $scope.brushFilterType;
  $scope.getDefaultSelection = function () {
    return $scope.data ? [0, $scope.data.length] : [0, 1];
  };
  $scope.removeData = function () {
    $scope.data = undefined;
    $scope.allData = undefined;
  };
  $scope.initChart = function (resetSelection, triggerBrush, silent) {
    return reloadChart().then(function () {
      if (_.isArray($scope.data) && $scope.data.length > 0) {
        if (resetSelection) {
          $scope.resetSelection(silent);
        }
        if (triggerBrush) {
          triggerDefaultBrushEvent();
        }
      }
    }).then(function () {
      $scope.$broadcast('perfect-scrollbar:update');
    });
  };
  $scope.reloadChartsDuringMaximize = function (currentExpansionState, prevExpansionState, chartSelections) {
    var index = getIntendedExpansionIndex($scope.mode, $scope.screen);
    if (currentExpansionState[index] !== prevExpansionState[index] && !currentExpansionState[index] && _.isEqual(chartSelections, [null])) {
      $timeout(function () {
        $scope.initChart(true, true, true);
      }, 0);
    }
  };
  function getIntendedExpansionIndex(mode, screen) {
    if (screen === gridMaximizeConstants.FLIGHT_SCREEN) {
      return 0;
    }
    return _.get(gridMaximizeConstants.MODE_INDEX_MAP, mode);
  }
  $scope.resetSelection = function (silent) {
    $scope.setInitialSelection(silent);
    $scope.handleBrushEnd(silent);
  };
  $scope.resetChart = function () {
    $scope.mode = currentStateCriteriaService.isPostDeparture() ? $scope.postDepartureModeName : $scope.defaultMode;
    var hasData = $scope.data !== undefined;
    $scope.removeData();
    $scope.initChart(true, true, !hasData);
  };
  $scope.redrawChartWithNewFilter = function () {
    reloadChart();
  };
  function fillInEmptyBars() {
    _.forEach($scope.data, function (item) {
      item.isHidden = true;
    });
  }
  function setBarToHidden() {
    return chartsWhichBarsShouldNotBeHidden.indexOf($scope.label) < 0;
  }
  function orderAndMergeDataBars(currentData, newData) {
    var orderedAndMergedBars = _.cloneDeep(newData);
    _.each(orderedAndMergedBars, function (newItem, i) {
      newItem.isHidden = false;
    });
    _.each(currentData, function (oldItem, i) {
      var oldItemIndexInNewItems = _.findIndex(newData, function (newItem) {
        return newItem.label === oldItem.label;
      });
      if (oldItemIndexInNewItems === -1) {
        oldItem.isHidden = setBarToHidden();
        orderedAndMergedBars.splice(i, 0, oldItem);
      }
    });
    return orderedAndMergedBars;
  }

  /**
   * This function is required for the empty gaps to show up when user filters the selection
   */
  $scope.mergeWithNewData = function (newAllViewsData) {
    var dataRepresentation = $scope.screenState.dataRepresentation;
    var currentData = $scope.allData && $scope.allData[dataRepresentation];
    var dataCopy = _.cloneDeep(currentData);
    var newData = newAllViewsData && newAllViewsData[dataRepresentation];
    if (currentData && newData) {
      $scope.allData[dataRepresentation] = orderAndMergeDataBars(currentData, newData);
    } else if (newAllViewsData) {
      $scope.allData = newAllViewsData;
    }
    $scope.data = $scope.allData ? $scope.allData[dataRepresentation] : [];
    if (!newAllViewsData) {
      fillInEmptyBars();
    }
    if (isOnHiddenFilteredBarClick(dataCopy, newData)) {
      $scope.handleBrushEnd();
      return $q.reject();
    }
    return $scope.data;
  };
  function isOnHiddenFilteredBarClick(data, newData) {
    var bar = $scope.brushFilter ? $scope.brushFilter.getArguments() : [];
    var label = _.head(bar);
    return bar.length === 1 &&
    // one bar clicked
    _.some(data, {
      'label': label,
      'isHidden': true
    }) &&
    // check if that bar is hidden current data model
    _.some(newData, {
      'label': label
    }); // check if bar if still available after filtering
  }
  _.forEach($scope.switchingModes, function (mode) {
    $scope.$on($scope.screen + '-' + mode + ':metricChanged', reloadChart);
    $scope.$on($scope.screen + '-' + mode + ':dimensionChanged', reloadChart);
  });
  $scope.$watch('screenState.selectedReference', function () {
    if (_.get($scope, ['screenState', 'searchReady'])) {
      reloadChart();
    }
  });
  /**
   * This will reinitialize the chart after some interaction is made with other charts
   */
  $scope.$on('brush-filter:filterApplied', function (event, brushFilter) {
    var isArray = Array.isArray($scope.listenedBrushNames);
    if (isArray && $scope.listenedBrushNames.indexOf(brushFilter.filterType) !== -1 || !isArray && brushFilter.filterType !== $scope.brushFilterType) {
      $scope.initChart(false, true).then(function () {
        if (brushFilter.reset) {
          $scope.handleBrushEnd();
        }
      });
    }
  });
  $scope.$on('brush-filter:resetCharts', function () {
    $scope.resetSelection();
  });
  $scope.handleBrushEnd = function (silent) {
    //this line renders the other 3 charts
    $scope.brushFilter = new BrushSelectionFilter($scope.brushFilterType, brushRangesService.getDataRange($scope.data, $scope.ranges));
    $scope.brushFilter.barsWithData = getSelectedBarsWithData();
    $scope.brushFilter.barCount = $scope.data ? $scope.data.length : 0;
    $scope.$emit('brush-filter:filterApplied', $scope.brushFilter, silent);
  };
  $scope.onDataRepresentationChange = function () {
    if ($scope.allData) {
      $scope.data = $scope.allData[$scope.screenState.dataRepresentation];
    }
    if ($scope.data) {
      $scope.renderChart($scope.data);
    }
  };
  function getRetrieverMode(screen, mode) {
    var retrieverMode = mode;
    if (screen === dataRetrieverConstantsService.FLIGHT_SCREEN && currentStateCriteriaService.isPostDeparture()) {
      retrieverMode = $scope.postDepartureModeName;
    }
    return retrieverMode;
  }

  /**
   * Fetch data and render the chart
   * @return {*}
   */
  function reloadChart() {
    $scope.setLoadingMessage();
    var screen = dataRetrieverConstantsService[$scope.screen];
    return dataProviderService.getData(screen, getRetrieverMode(screen, $scope.mode), $scope.type).then($scope.mergeWithNewData).then($scope.renderChart);
  }

  /**
   * Propagate brush filter to other charts
   */
  function triggerDefaultBrushEvent() {
    var brushFilterData = _.map($scope.data, 'label');
    var brushFilter = new BrushSelectionFilter($scope.brushFilterType, brushFilterData);
    brushFilter.barsWithData = getSelectedBarsWithData();
    $scope.$emit('brush-filter:defaultBrush', brushFilter);
  }
  function getSelectedBarsWithData() {
    var rangesSize = brushRangesService.getNumberOfRanges($scope.ranges);
    return Array.isArray($scope.data) && rangesSize !== $scope.data.length ? _.chain($scope.ranges).map(function (range) {
      range = range.map(function (entry) {
        return Math.ceil(entry);
      });
      return getRangeLabelsWithData(range);
    }).flatten().value() : getRangeLabelsWithData($scope.ranges[0]);
  }
  function getRangeLabelsWithData(range) {
    if (range.length === 2) {
      return _.chain($scope.data.slice(range[0], range[1])).reject('isHidden').map('label').value();
    }
  }
};
ThematicBarChartController.$inject = ['$timeout', '$scope', '$filter', '$q', 'BrushSelectionFilterFactory', 'ThematicBarChartDataProviderService', 'FormatterService', 'CurrentStateCriteriaService', 'DataRetrieverConstantsService', 'DowConversionService', 'BrushRangesService', 'UserPreferencesService', 'DataRepresentationService', 'AnalysisMetricService', 'GridMaximizeConstants'];
module.exports = ThematicBarChartController;